import React from 'react';

const ForgotPasswordPageConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: true,
        },
        footer: {
          display: true,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      auth: null,
      path: '/pages/auth/forgot-password',
      component: React.lazy(() => import('./ForgotPasswordPage')),
    },
  ],
};

export default ForgotPasswordPageConfig;
